import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sending-page',
  templateUrl: './sending-page.component.html',
  styleUrls: ['./sending-page.component.scss']
})
export class SendingPageComponent {

  constructor() { }

}
